import { Form } from "@circle-react-uikit/Form";

export interface TextProps {
  label: string;
  labelClassName: string;
  name: string;
}

export const Text = ({ name, label, labelClassName }: TextProps) => (
  <div className="py-3">
    <Form.Item
      name={name}
      label={label}
      hideDescription
      hideBorder
      labelClassName={labelClassName}
      className="!p-0"
    >
      <Form.Input name={name} />
    </Form.Item>
  </div>
);
